"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var marketingRouter = {
  path: '/market',
  component: _layout.default,
  redirect: '/market/list',
  name: 'Market',
  meta: {
    title: '集市',
    icon: 'fork-spoon'
  },
  children: [{
    path: 'list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/market/list'));
      });
    },
    name: 'MarketList',
    meta: {
      title: '集市列表',
      icon: ''
    }
  }, {
    path: 'add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/market/add'));
      });
    },
    name: 'AddMarket',
    meta: {
      title: '添加集市',
      activeMenu: "/market/list"
    },
    hidden: true
  }, {
    path: 'activity/list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/market/activity/list'));
      });
    },
    name: 'MarketActivity',
    meta: {
      title: '活动管理',
      icon: ''
    }
  }, {
    path: 'activity/add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/market/activity/add/index'));
      });
    },
    name: 'MarketActivityAdd',
    meta: {
      title: '活动添加',
      activeMenu: "/market/activity/list"
    },
    hidden: true
  }, {
    path: 'activity/apply/list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/market/activity/apply/list'));
      });
    },
    name: 'MarketActivityApplyList',
    meta: {
      title: '报名列表',
      icon: ''
    }
  }, {
    path: 'activity/apply/add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/market/activity/apply/add'));
      });
    },
    name: 'MarketActivityApplyAdd',
    meta: {
      title: '报名添加',
      activeMenu: "/market/activity/apply/list"
    },
    hidden: true
  }, {
    path: 'activity/apply/edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/market/activity/apply/add'));
      });
    },
    name: 'MarketActivityApplyEdit',
    meta: {
      title: '报名编辑',
      activeMenu: "/market/activity/apply/list"
    },
    hidden: true
  }, {
    path: 'life-vibes-point',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/lifeVibesPoint/list'));
      });
    },
    name: 'LifeVibesPointList',
    meta: {
      title: '烟火地图管理',
      icon: ''
    }
  }, {
    path: 'life-vibes-point/form',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/lifeVibesPoint/form'));
      });
    },
    name: 'LifeVibesPointForm',
    meta: {
      title: '烟火点位编辑',
      activeMenu: '/market/life-vibes-point'
    },
    hidden: true
  }]
};
var _default = exports.default = marketingRouter;